import Highcharts from 'highcharts';
import {numberRange} from './utilities';
const categories = numberRange(1, 6);

export const figure51 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        },
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    plotOptions: {
        series: {
            colorByPoint: true,
            colors: [
                '#ffc000','#ffc000','#ffc000','#ffc000','#ffc000','#ffc000',
                '#00b050','#00b050','#00b050','#00b050','#00b050','#00b050',
                '#92d050','#92d050','#92d050','#92d050','#92d050','#92d050',
                '#e7e6e6','#e7e6e6','#e7e6e6','#e7e6e6','#e7e6e6','#e7e6e6',
                '#b67e80','#b67e80','#b67e80','#b67e80','#b67e80','#b67e80',
                '#93b7d7','#93b7d7','#93b7d7','#93b7d7','#93b7d7','#93b7d7',
            ]
        }
    },
    exporting: {
        enabled: false
    },
    xAxis: {
            tickWidth: 0,
            categories: [
                {
                    name: "Tierra cultivable",
                    categories: categories
                },
                {
                    name: "Bosque",
                    categories: categories
                },
                {
                    name: "Pastizales",
                    categories: categories
                },
                {
                    name: "Otras tierras",
                    categories: categories
                },
                {
                    name: "Asentamientos",
                    categories: categories
                },
                {
                    name: "Humedales",
                    categories: categories
                }
            ],
            title: {
                text: null,
                style: {
                    color: Highcharts.getOptions().colors[1]
                }
            },
    },
    yAxis: {
            title: {
                text: null
            },
            gridLineWidth: 2,
            floor: 0,
            ceiling: 80,
            tickInterval: 10,
            lineColor: "#d7d7d7",
            tickColor: "#d7d7d7",
            tickLength: 16,
            labels: {
                style: {
                    fontWeight: 'normal',
                    color: '#999999',
                    fontSize: '12px'
                },
            },
    },
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    series: [
    {
            name: null,
            color: '#5b9bd5',
            data: [ 
2.594295978,
4.916606272,
4.617612511,
9.952129556,
8.128094295,
8.841384973,
0.546394852,
9.75494175,
14.23865993,
33.25507149,
43.06132214,
49.47997506,
69.02078567,
54.93801756,
20.85244592,
31.61306237,
23.42028919,
19.56696463,
27.71765772,
30.17721929,
60.08939574,
24.94266381,
24.98291216,
21.35357316,
0.003730994,
0.054288099,
0.079344943,
0.1110966,
0.126371093,
0.211970025,
0.117134785,
0.158927032,
0.122540957,
0.125976166,
0.281011127,
0.54613214
             ]
    }
    ]
}
